import { a } from "./appColors";
import { STANDE } from "../StandeClassroom/standeTokens";

/**
 * The two kinds of filled button Stande uses. Orange is not one of them: it
 * is kept back for the few places it means something, not for "press here".
 *
 * Spread onto a Chakra Button: `<Button {...solidButton}>`. Size, padding and
 * radius stay with the button, which knows its place on the page.
 */

/** Black with a cream label, the default for an action. Flips with the theme
 *  through the ink tokens, so it stays the strong button in dark mode. */
export const solidButton = {
  bg: a.ink,
  color: a.onInk,
  border: "1px solid",
  borderColor: a.ink,
  _hover: { bg: a.ink, color: a.onInk, opacity: 0.86 },
  _active: { bg: a.ink, opacity: 0.8 },
};

/** Stande blue with a black label, for the one thing on a screen that starts
 *  something — and for buttons sitting on a black dialog, where black would
 *  disappear. */
export const blueButton = {
  bg: STANDE.primaryBlue,
  color: STANDE.black,
  border: "1px solid",
  borderColor: STANDE.primaryBlue,
  _hover: { bg: STANDE.primaryBlue, color: STANDE.black, filter: "brightness(0.94)" },
  _active: { bg: STANDE.primaryBlue, filter: "brightness(0.9)" },
};
